import React, { useMemo } from "react";
import { motion } from "framer-motion";

// Renders a starfield of glowing dots that drift gently.
export default function CosmicField({ count = 60 }) {
    const stars = useMemo(() => {
        const arr = [];
        for (let i = 0; i < count; i++) {
            arr.push({
                id: i,
                x: Math.random() * 100,
                y: Math.random() * 100,
                r: 2 + Math.random() * 4,
                delay: Math.random() * 4,
                dur: 4 + Math.random() * 4,
                hue: [
                    "#FFC107",
                    "#FFFFFF",
                    "#FF2052",
                    "#3EB489",
                    "#6F00FF",
                    "#8BCDF8",
                ][i % 6],
            });
        }
        return arr;
    }, [count]);

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {stars.map((s) => (
                <motion.div
                    key={s.id}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: [0.2, 1, 0.4], y: [0, -6, 0] }}
                    transition={{ duration: s.dur, delay: s.delay, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute rounded-full"
                    style={{
                        left: `${s.x}%`,
                        top: `${s.y}%`,
                        width: s.r,
                        height: s.r,
                        background: s.hue,
                        boxShadow: `0 0 12px ${s.hue}`,
                    }}
                />
            ))}
        </div>
    );
}
